import type { HostCapabilities } from "../../capabilities";
import type { MarlinStoreDb } from "../infra/db";
import * as ops from "./store";

export const createNotificationsApi = (
  db: MarlinStoreDb,
  { windows }: Pick<HostCapabilities, "windows">,
  screenId: number,
) => ({
  getNotifications: (filter?: Parameters<typeof ops.getNotifications>[1]) =>
    ops.getNotifications(db, filter),
  addNotification: (incoming: Parameters<typeof ops.addNotification>[1]) =>
    ops.addNotification(db, incoming),
  clearNotification: (id: Parameters<typeof ops.clearNotification>[1]) =>
    ops.clearNotification(db, id),
  clearNotificationsInBulk: (
    ids: Parameters<typeof ops.clearNotificationsInBulk>[1],
  ) => ops.clearNotificationsInBulk(db, ids),
  updateNotification: (
    machineId: Parameters<typeof ops.updateNotification>[1],
    id: Parameters<typeof ops.updateNotification>[2],
    updates: Parameters<typeof ops.updateNotification>[3],
  ) => ops.updateNotification(db, machineId, id, updates),
  soundFor: (notification: Parameters<typeof ops.soundFor>[1]) =>
    ops.soundFor(db, notification),
  getSoundNotifications: (afterRowId: number) =>
    ops.getSoundNotifications(db, afterRowId),
  getSoundScreenId: async () => {
    const connected = (await windows?.connectedScreenIds()) ?? [screenId];
    return connected.includes(1) ? 1 : connected[0];
  },
});

export type NotificationsApi = ReturnType<typeof createNotificationsApi>;
